import { deepUpdate, update } from '../../../utils/vuex'
import { forIn } from '../../../utils/base'

export default {
    deepUpdate,
    update,
}